import { useEffect, RefObject } from 'react';

/**
 * Custom hook to handle click outside detection
 * Closes dropdown when clicking outside the container and dropdown
 */
export const useClickOutside = (
  isOpen: boolean,
  containerRef: RefObject<HTMLDivElement>,
  dropdownRef: RefObject<HTMLDivElement>,
  onClose: () => void
): void => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      const target = event.target as Node;
      const isClickInsideContainer = containerRef.current?.contains(target);
      const isClickInsideDropdown = dropdownRef.current?.contains(target);

      if (!isClickInsideContainer && !isClickInsideDropdown) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, containerRef, dropdownRef, onClose]);
};

